import { PostgrestClient } from '@supabase/postgrest-js';
import { environment } from 'src/environments/environment';
import type { BlumenauDatabase, GenericDatabase } from '.';

export type Databases = {
  blumenau: BlumenauDatabase.Database;
  vm2: GenericDatabase.Database;
};

const isEtopocartProd = environment.isETopocartProd;

// id: 'vm2' -> Geo360 database (vm2)
// id: ':cityName' -> City database (:cityName)

export const BASE_POSTGREST_URL = (id: string) => {
  const postgrestUrl = environment.postgRestUrl.replace('<placeholder>', id)
  return postgrestUrl;
};

export const postgrestClients = new Map();

export const postgrestClient = <T>(
  id = 'plataforma'
): PostgrestClient<T> => {
  if (postgrestClients.has(id)) {
    return postgrestClients.get(id);
  }

  const url = BASE_POSTGREST_URL(id);
  const postgrestClient = new PostgrestClient<T>(url);
  postgrestClients.set(id, postgrestClient);

  return postgrestClient;
};
